import { createAction } from '@reduxjs/toolkit'
import { DeviceListParams, UpdateDeviceAliasParams } from '@repo/user-types/src/lib/devices'

export {
  addTrustDeviceActions,
  changePasswordActions,
  checkUserActions,
  convenienceTestQuestionnaireActions,
  convenienceTestQuestionnaireAnswersActions,
  convenienceTestsConfirmActions,
  convenienceTestsDataActions,
  convenienceTestsDraftActions,
  convenienceTestsDraftPdfDownloadActions,
  deleteDeviceSigningDataActions,
  deleteDeviceTrustedDataActions,
  devicesDataActions,
  deviceSigningDataActions,
  editUserDataActions,
  editUserInfoActions,
  editUserPreferencesActions,
  mailingAddressRelatedProductsDataActions,
  otpResendActions,
  recoverPasswordActions,
  refreshTokenDeviceActions,
  securityDataActions,
  taxAddressRelatedProductsDataActions,
  updateDeviceAliasActions,
  userInfoDataActions,
  userPreferencesDataActions,
} from '../slices'

export const deviceActions = {
  saveEditAlias: createAction<UpdateDeviceAliasParams & DeviceListParams>(
    '@users/devices/saveEditAlias',
  ),
}

export const contactDataFormActions = {
  initContactDataForm: createAction('@users/userInfo/contactData/initContactDataForm'),
}
export const clearConvenienceTestAction = createAction('@users/convenienceTest/clear')
